import { base58 } from '@scure/base';
import { fmtHs } from 'format-utils';
import { JSEncrypt } from 'jsencrypt';
import { DialogPlugin } from 'tdesign-vue-next';
import { Dialog } from '@varlet/ui'
import { h, markRaw, nextTick } from 'vue';
import { toast as sonner } from 'vue-sonner';
import { RSA_PRIVATE_KEY, RSA_PUBLIC_KEY } from '../config/global';
import { minW } from '../constants/index';
import { getKeyStr, getKeyJson, removeKeys } from './localStorage';
import { isReactive, toRaw, } from 'vue'

import { useUserStore } from '../store/modules/user';

/** *
 * toast : message 提示框
 * msg : content
 * type : 0-info ,1-succ, 2-warning 3-error, 4-question， 5-loading，6-关闭所有
 * *** */

//控制是否打印，正式版本不打印
let debug = -1;//未定义
function getLogLine(stack: string[]) {
  let line = 'null';
  let callerLine = '';
  if (stack.length > 2) {
    // 获取调用处的堆栈行（浏览器环境通常为索引2）
    callerLine = stack[2];
    /*if(callerLine){
      const index = callerLine.lastIndexOf('/');
      if(index !== -1){
        line = callerLine.substring(index + 1);
      }
    }*/
  }
  return callerLine;//`<a href="${callerLine}">${line}</a>`;
}


// 判断终端
// web类型：pc访问，移动端访问

let ismobile: any;
/** 非null表示移动 */
export function isMobile() {
  if (isN(ismobile)) {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    // console.log(`navigator.userAgent: ${navigator.userAgent}, flag: ${flag}`);
    ismobile = flag;
  }
  return ismobile;
};

// web类型：pc访问，移动端访问--短期token
// 小程序：微信小程序2，安卓APP小程序11，iOS的APP小程序12 --长期token
export function isMiniProgram() {
  const ua = navigator.userAgent.toLowerCase();
  // 登录的时候修改navigator.userAgent.toLowerCase()值，app给后缀加上micromessenger
  // console.log('userAgent',ua)

  // 微信内置浏览器和微信小程序都会带 micromessenger，只有小程序才返回 2
  const isWechat = /micromessenger/.test(ua);
  if (isWechat) {
    const wxEnv = (window as any).__wxjs_environment;
    const isWechatMiniProgram = /miniprogram/.test(ua) || wxEnv === 'miniprogram';
    if (isWechatMiniProgram) {
      //iOS微信特征
      if (ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)) {
        return 2;
      }
      //安卓特性
      if (ua.indexOf('android') > -1 || ua.indexOf('adr') > -1) {
        return 1;
      }
    } else {// 微信浏览器和web一样都走0
      return 0;
    }
  } else if (/appmessenger/.test(ua)) {
    //是app返回10~20,它是独立安装移动应用，需要app对ua进行修改才能实现
    return 10
  }

  //0就是pc上web访问，在手机上使用浏览器访问
  return 0;
};

/*
解决移动设备上的视口高度问题：
在移动设备上，视口高度会随着键盘的弹出和隐藏而变化。使用 100dvh 可以确保元素的高度始终等于设备的屏幕高度。
提高布局的稳定性：使用 100dvh 可以确保布局的稳定性，不会受到视口高度的影响。
简化布局的设计：使用 100dvh 可以简化布局的设计，不需要考虑视口高度的变化。

但是，使用 100dvh 也有一些坏处：
兼容性问题：100dvh 是一个新的 CSS 单位，可能不被所有浏览器支持。
设备高度的限制：使用 100dvh 会将元素的高度限制为设备的屏幕高度，这可能会导致布局的灵活性降低。
可能导致滚动问题：如果元素的高度超过设备的屏幕高度，使用 100dvh 可能会导致滚动问题。
*/

const supportsDvh = (() => {
  const testElement = document.createElement('div');
  testElement.style.display = 'none'; // 添加这一行
  document.body.appendChild(testElement);
  const rect = testElement.getBoundingClientRect();
  const height = rect.height;
  document.body.removeChild(testElement);
  return height === window.innerHeight;
})();

// 获取满视窗高度，supportsDvh被缓存，不会被调用多次
export function dvh100() {
  return supportsDvh ? '100dvh' : '100vh';
}


//小数相乘避免精度丢失
export function mathMul(arg1: number, arg2: number) {
  let m = 0;
  let s1 = arg1.toString();
  let s2 = arg2.toString();
  try { m += s1.split(".")[1].length } catch (e) { ; }
  try { m += s2.split(".")[1].length } catch (e) { ; }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / 10 ** m
}


export function accDiv(arg1: number, arg2: number) {
  let t1 = 0;
  let t2 = 0;
  let r1: number;
  let r2: number;
  try { t1 = arg1.toString().split(".")[1].length } catch (e) { ; }
  try { t2 = arg2.toString().split(".")[1].length } catch (e) { ; }
  //with(Math){
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return (r1 / r2) * 10 ** (t2 - t1);
  //}
}
export function toast(msg: any, type = 0) {
  // - 将toast实现切换为 vue-sonner。
  // - 类型保持不变：0-info/1-success/2-warning/3-error/4-question(退化为info)/5-loading/6-closeAll。
  //- 位置 ,vue-sonner 使用 Toaster 的 position 统一控制，这里不直接生效。
  // - 可选 show.duration 透传给 vue-sonner 的 duration。
  // if(!msg) return; 此处不宜堵截
  const duration = 3000; //固定一秒,tdesig默认是3秒
  console.log('[toast] call', { msg, type, duration });
  // 之前增加了 500ms 延迟以规避某些场景不显示的问题，这里保留
  setTimeout(() => {
    try {
      switch (type) {
        case 1:
          sonner.success(msg, { duration });
          break;
        case 2:
          sonner.warning(msg, { duration });
          break;
        case 3:
          sonner.error(msg, { duration });
          break;
        case 4:
          // vue-sonner 无 question 主题，自定义可传 icon
          sonner(msg, { duration });
          break;
        case 5:
          // loading 常驻，需调用 dismiss 关闭
          sonner.loading(msg, { duration });
          break;
        case 6:
          // 关闭全部
          sonner.dismiss();
          break;
        default:
          sonner(msg, { duration });
          break;
      }
      //console.log('toast展示成功')
    } catch (e) {
      console.error('toast展示失败', e);
    }
  }, 500);
}
// export function toast(msg:any, type = 0, place: MessagePlacementList = 'top') {
//   //if(!msg) return; 此处不宜堵截
//   const mObj: MessageInfoOptions = { content: msg, placement: place };
//   //todo 之前比如商机明细 添加 toast无反应，还有很多场景，增加setTimeout发现可以解决
//   setTimeout(()=>{
//     switch (type) {
//       case 1:
//         MessagePlugin.success(mObj);
//         break;
//       case 2:
//         MessagePlugin.warning(mObj);
//         break;
//       case 3:
//         MessagePlugin.error(mObj);
//         break;
//       case 4:
//         MessagePlugin.question(mObj);
//         break;
//       case 5:
//         MessagePlugin.loading(mObj);
//         break;
//       case 6:
//         MessagePlugin.closeAll();
//         break;
//       default:
//         MessagePlugin.info(mObj);
//         break;
//     }
//     //toto 1就出不来toast,为什么？
//   },500);
// }


//f_rsp: "设备当前不在线"
//m_dur: 2000
//m_p: 2
//msg: "操作失败：%s"
//thm: "error"
//tp: 2
export function generateToast(param: any) {
  const { fid, fitem: confMsg } = param;
  nextTick(() => {
    const options = {
      duration: confMsg.m_dur || 2000,
      zIndex: 1000100,
      placement: getToastMessagePlace(confMsg)
    };

    //原始内容
    const content = getToastMsg(confMsg) || confMsg['t'];

    //要toast的内容
    let toastContent: any;
    if (typeof confMsg['f_rsp'] === 'string' &&
      (confMsg['f_rsp'].includes('<br>') || confMsg['f_rsp'].includes('<br/>') || confMsg['f_rsp'].includes('<br />'))) {

      toastContent = markRaw({
        render() {
          return h('div', {
            //有可能有{h}/{s}     
            innerHTML: fmtHs(content),
            style: 'font-size:12px;'
          });
        }
      });
      //todo 这个方案临时，后面需要样式传入
      //给30秒，打开手机扫描
      options['duration'] = 30 * 1000;
      sonner.warning(toastContent, options);
      return;
    } else {
      toastContent = content;
    }

    if (content) {
      if (confMsg['thm'] === 'error') {
        sonner.error(toastContent, options);
      } else if (confMsg['thm'] === 'success') {
        sonner.success(toastContent, options);
      } else if (confMsg['thm'] === 'warning') {
        sonner.warning(toastContent, options);
      } else {
        sonner(toastContent, options);
      }
    }
  });
}

// 消息(可能是数组)
const getToastMsg = (confMsg) => {
  let msgstr = confMsg['msg'] || '';

  // 如果要连接结果，则显示
  let rsp = '';
  if (msgstr.includes('%s')) {
    if (Array.isArray(confMsg['f_rsp'])) {
      // 是数组，组成换行 - 使用 \n 而不是 <br>
      if (confMsg['f_rsp'].length > 0) {
        // 为每个数组元素添加适当的缩进
        confMsg['f_rsp'].forEach((its, index) => {
          if (isJson(its)) {
            rsp += `\n    ${JSON.stringify(its)}`;  // 使用 \n 和空格缩进
          } else {
            rsp += `\n    ${its}`;  // 使用 \n 和空格缩进
          }
        });
      }
    } else {
      // 不是数组，直接添加
      rsp = confMsg['f_rsp'];
    }

    msgstr = msgstr.replace('%s', rsp);
  }

  if (msgstr === '') {
    msgstr = '错误（没有信息）';
  }

  // 返回纯文本字符串，使用 \n 作为换行符
  // Sonner 会自动处理 \n 为换行
  return msgstr;
};

const getToastMessageIcon = (conf) => {
  if (!['success', 'info', 'warning', 'error'].includes(conf.thm)) {
    return conf.thm;
  }
  return 'info-circle';
}


// 位置
const getToastMessagePlace = (conf) => {
  return conf.m_p === 1
    ? 'top-left'
    : conf.m_p === 2
      ? 'top'
      : conf.m_p === 3
        ? 'top-right'
        : conf.m_p === 4
          ? 'left'
          : conf.m_p === 5
            ? 'center'
            : conf.m_p === 6
              ? 'right'
              : conf.m_p === 7
                ? 'bottom-left'
                : conf.m_p === 8
                  ? 'bottom'
                  : conf.m_p === 9
                    ? 'bottom-right'
                    : 'center';
};

/** ***密码rsa加密 depu 2022/7/16************* */
export function encodePass(pas, pubKey = RSA_PUBLIC_KEY) {
  const pass = pas;
  const jsencrypt = new JSEncrypt();
  jsencrypt.setPublicKey(pubKey);
  const signdata: any = jsencrypt.encrypt(pass);
  return signdata;
}

export function decodeBase58(base58Str: string) {
  const decodedBytes = base58.decode(base58Str);
  return new TextDecoder().decode(decodedBytes);
}

export function encodeBase58(plainUint8Array: Uint8Array) {
  return base58.encode(plainUint8Array);
}


//解密失败返回false
export function decPass(endPwd, priKey = RSA_PRIVATE_KEY) {
  const jsencrypt = new JSEncrypt();
  jsencrypt.setPrivateKey(priKey);
  return jsencrypt.decrypt(endPwd);//返回false或解密字符
}

/** **首页计算* */
export function firstUrl(mlist) {
  if (mlist.length > 0) {
    try {
      let rootMenu = mlist[0];
      // 递归查找子菜单路径
      let currentMenu = rootMenu;
      let url = rootMenu['path']; // 获取根路径
      while (currentMenu['children'] && currentMenu['children'].length > 0) {
        currentMenu = currentMenu['children'][0]; // 取第一个子菜单
        url = `${url}/${currentMenu['path']}`;
      }

      return url;
    } catch (e) {
      console.error(e);
    }
  }

  // 如果没有子菜单，直接返回根菜单路径
  try {
    let url = mlist[0]['path'];
    if (url) {
      return url;
    }
  } catch (e) {
    console.error(e);
  }

  toast('没有配置首页', 3);
  return '/404';
}

/**login跳转，默认login，如果用户配置了，则使用配置的 **/
export function loginHref(reDirectUrl: any) {
  //不做path检查如果没有登录信息，会一直报错
  let login = getKeyJson('login');
  let lastPart = '';
  if (login && login['path']) {
    lastPart = login['path'];
  }

  let url = `${window.location.origin}${window.location.pathname}#${lastPart}`;
  if (reDirectUrl && reDirectUrl !== '/') {
    url += `?redirect=${reDirectUrl}`;
  }

  window.location.assign(url);
}

/** 鉴权超期或其它地方登录 102, 105 --*/
export function authExpired(info: any) {
  reLoginDlg('warning', info);
}
export function isPc(): boolean {
  const userAgent = navigator.userAgent.toLowerCase()

  const mobileReg =
    /android|iphone|ipad|ipod|windows phone|mobile|blackberry|symbian|webos/i

  return !mobileReg.test(userAgent)
}
/** 弹窗提示用户重新登录，可以定制弹窗的样式。 场景如：密码更新成功 --*/
export function reLoginDlg(thm: any, info: any) {
  //此处是退出重新登录，缓存使用logout
  const userStore = useUserStore();
  userStore.logout();
  //let ropath  =  '';//getKeyStr('currentPath');
  // toast(value || '登录信息失效,请重新登陆', 3);
  let confirmDia = null;
  if (isPc()) {
    confirmDia = DialogPlugin.alert({
      header: '提示信息',
      width: `${minW()}`,
      body: info || '登录信息失效,请重新登陆',
      theme: thm,
      confirmBtn: '确定',
      onConfirm: ({ e }) => {
        confirmDia.destroy();
        loginHref(undefined);
      },
      onClose: (e) => {
        confirmDia.destroy();
        loginHref(undefined);
      },
    });
    return;
  }
  Dialog({
    title: '提示信息',
    message: info || '登录信息失效,请重新登陆',
    confirmButtonText: '确定',
    width: `${minW()}`,
    onConfirm: () => {
      loginHref(undefined);
    },

    onClose: () => {
      loginHref(undefined);
    },
  });
}

/**为null或undefined返回true*/
export function isN(any: any) {
  return any === undefined || any === null;
}

/** 去掉尾巴上的指定字符 */
export function trimEnd(data: string, trimChar: string) {
  if (!trimChar || !data) {
    return data;
  }

  if (data.endsWith(trimChar)) {
    return data.substring(0, data.length - trimChar.length);
  }
  return data;
}

/** 去掉尾巴上的某1个字符直到遇到某个字符 */
export function trimEnd1Until(data: string, trimChar: string, until: string) {
  if (isN(trimChar) || isN(data) || isN(until) || trimChar === until) {
    return data;
  }

  if (data.endsWith(trimChar)) {
    let rtn = data.substring(0, data.length - trimChar.length);
    if (rtn.endsWith(until)) {
      return rtn;
    }
    //递归
    return trimEnd1Until(rtn, trimChar, until);
  }
  return data;
}


export function isNN(any: any) {
  return any !== undefined && any !== null;
}

/**根据一个类获取其元素的高度*/
export function docHeightByCls(cls: string) {
  const tab = document.querySelector(cls) as HTMLElement;
  let tabHeight: number = 0;
  if (tab) {
    let t = tab.clientHeight;
    tabHeight = tab.offsetHeight;
  }
  return tabHeight;
}

/**根据一个类获取其元素的高度*/
export function docHeightById(id: string) {
  const tab = document.getElementById(id) as HTMLElement;
  let tabHeight: number = 0;
  if (tab) {
    //let t = tab.clientHeight;
    tabHeight = tab.offsetHeight;
  }
  return tabHeight;
}

/**根据一个类获取其元素，然后设置样式。仅对当前路由生效*/

/**根据一个类获取其元素，然后设置样式。仅对当前路由生效*/
export function docCssByCls(cls: string, val: string) {
  const dom = document.querySelector(cls) as HTMLElement;
  if (dom && val) {
    // dom.setAttribute('style', val);

    //追加 不要用上面的覆盖
    dom.style.cssText += (dom.style.cssText ? ';' : '') + val;
    //const style= dom.getAttribute('style');
    //style[key] = val;
    return true;
  }
  return false;
}

/** 设置属性，必须以;结束 */
export function docCssById(id: string, val: string) {
  const dom = document.getElementById(id) as HTMLElement;
  if (dom && val) {
    // dom.setAttribute('style', val);

    //追加 不要用上面的覆盖
    dom.style.cssText += (dom.style.cssText ? ';' : '') + val;

    return true;
  }
  return false;
}

/**预期为字符串或数组时，不能为空。用于确认为null或undefined或空字符返回true。*/
export function isEmpty(any: any) {
  return any === undefined || any === null || any.length === 0;
}

/**判断是null,undefined或者空字符*/
export function isBlank(any: any) {
  if (any === undefined || any === null || any.length === 0) return true;
  return `${any}`.trim() === '';
}

/** 判断是否数字。如果是数字不能返回数字，因为可能是0此时与false效果相同 */
export function isNum(any: any) {
  //Number("")的结果是0，所以要增加===''的判断
  if (any === undefined || any === null || `${any}`.trim() === '') return false;
  //如果返回false，表示结果不是数字
  //isNaN("3-2") = true  isNaN("-2") = false isNaN("90") = false isNaN(3) = false  ES5
  //Number.isNaN("3-2") = false  ES6
  //直接使用Number("3-2")这种，返回NaN来判断
  return !Number.isNaN(Number(any));
}


/**预期为字符串或数组时，不能为空。用于确认为null或undefined或空字符返回true。*/
export function isNEmpty(any: any) {
  return any !== undefined && any !== null && any.length > 0;
}

export function sleepSync(ms: number) {
  const start = new Date().getTime();
  while (new Date().getTime() - start < ms) {
    // 继续循环
  }
}
/** 调用方法 await sleep()*/
export function sleepMs(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}


/** 判断一个不知类型数据是不是Json(数组类型的JSON不算) */
export function isJson(obj: any) {
  if (obj === undefined && obj === null) return false;
  return typeof obj === 'object' && !Array.isArray(obj);
  //if(typeof any === "object"){
  //  return true;
  //}
  //return false
}

// ; (window as any).__jsonCount = 0

// 挂到 window 上
/** 判断是有值的Json，而不是空的Json。返回false有可能是Json空的Json也有可能不是Json */
export function isJsonV(any: any) {
  // ; (window as any).__jsonCount++
  if (isNN(any)) {
    try {
      if (JSON.stringify(any).startsWith('{"')) {
        return Object.keys(any).length > 0;
      }
    } catch (e) {
      return false;
    }
  }
  return false
}


// export function isJsonV(any:any){
//   // ; (window as any).__jsonCount++
//   if (!any || typeof any !== 'object') return false
//   for (const k in any) return true
//   return false
// }

/** 判断是空的Json。 返回false有可能是Json空的Json也有可能不是Json */
export function isJson0(any: any) {
  if (isN(any)) return false;
  return JSON.stringify(any) === '{}'
}

/** 判断一个字符串是不是Json字符串。如果是返回对应的Json对象 */
export function isJsonS(any: any) {
  if (any === undefined && any === null) return false;
  if (typeof any === "string") {
    try {
      const parsed = JSON.parse(any);
      if (parsed && typeof parsed === "object") {
        return parsed;
      }
    } catch (e) {
      return false
    }
  }
  return false
}

/** 保留两头文字数量，中间...替换*/
export function esp(sin: string, keepPre: number, keepPost: number) {
  if (isN(sin)) return undefined;
  if (sin.length <= keepPre + keepPost) return sin;
  if (keepPre < 0 || keepPost < 0) return sin;

  let rtn;
  if (keepPre > 0) {
    rtn = `${sin.substring(0, keepPre)}...`;
  } else {
    rtn = `...${sin}`
  }
  if (keepPost > 0) {
    rtn += sin.substring(sin.length - keepPost);
  }
  return rtn;
}

export function clearLs(keep: string[]) {
  const userStore = useUserStore();
  if (!getKeyStr('reme')) {
    removeKeys(['lgusr', 'reme']);
  }
  removeKeys(['tenant', 'auth', 'unid', 'uinfo', 'rool', 'setting',
    'hashCode', 'current', 'mainTable']);

  userStore.uinfo = {}; // 清理用户信息
  userStore.rool = {}; // 清理用户角色

}

export function getSubkey(data: any, subkey: Array<string>) {
  for (let i = 0; i < subkey.length; i++) {
    data = data[subkey[i]];
  }
  return data;
}




export function deepToRaw(obj: any): any {
  if (obj === null || typeof obj !== 'object') { return obj }

  // 当前层去响应式
  const raw = isReactive(obj) ? toRaw(obj) : obj

  // array
  if (Array.isArray(raw)) {
    return raw.map(item => {
      return deepToRaw(item)
    })
  }

  // object
  const result = {}

  Object.keys(raw).forEach(key => {
    result[key] = deepToRaw(raw[key])
  })

  return result
}
